/* Green Society — animations sobres (v2 fiabilisée, brief 4.1 du 02/07).
   - Ce qui est déjà à l'écran au chargement est révélé immédiatement
   - Filet de sécurité : tout élément observé est révélé au plus tard 1,8 s
     après sa connexion (gel de rendu, élément dans un carrousel, etc.)
   - Parallax coupé sur écrans tactiles
   Autonome (aucun import), respecte prefers-reduced-motion.
   Le masquage initial est conditionné à html.gs-anim (voir brand-animations.css). */

const GS_REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const GS_COARSE = window.matchMedia('(any-pointer: coarse)').matches;

/* <gs-reveal> : révèle doucement son contenu quand il entre dans l'écran. */
class GsReveal extends HTMLElement {
  connectedCallback() {
    if (GS_REDUCE || !('IntersectionObserver' in window)) {
      this.classList.add('is-revealed');
      return;
    }
    const rect = this.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      this.classList.add('is-revealed');
      return;
    }
    const threshold = Number(this.dataset.threshold || 0.08);
    this._observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.add('is-revealed');
            obs.unobserve(this);
          }
        });
      },
      { threshold, rootMargin: '0px 0px -10px 0px' }
    );
    this._observer.observe(this);
    this._failsafe = setTimeout(() => this.classList.add('is-revealed'), 1800);
  }
  disconnectedCallback() {
    if (this._failsafe) clearTimeout(this._failsafe);
    if (this._observer) this._observer.disconnect();
  }
}
if (!customElements.get('gs-reveal')) customElements.define('gs-reveal', GsReveal);

/* <gs-parallax> : translation verticale légère de l'élément [data-parallax-bg]
   au scroll. Throttlé par requestAnimationFrame. Desktop uniquement. */
class GsParallax extends HTMLElement {
  connectedCallback() {
    if (GS_REDUCE || GS_COARSE) return;
    this._bg = this.querySelector('[data-parallax-bg]');
    if (!this._bg) return;
    const strength = Number(this.dataset.strength || 0.12);
    let ticking = false;
    const update = () => {
      const rect = this.getBoundingClientRect();
      const offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -strength;
      this._bg.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      ticking = false;
    };
    this._onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll, { passive: true });
    update();
  }
  disconnectedCallback() {
    if (this._onScroll) {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
    }
  }
}
if (!customElements.get('gs-parallax')) customElements.define('gs-parallax', GsParallax);
